export default __webpack_public_path__ + "locales/en/Common.json?hash=7797c98a9dbb9fcc3cfbf8071644798f";